import { Course } from '@/client/courses';
import { AppButton, FlexContainer } from '@/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CourseContentPreview } from '../preview/CourseContentPreview';

export type CustomizeCoursePreviewStepProps = {
  course: Course;
  onSkipTranslation: () => void;
  onTranslate: () => void;
};

export const CustomizeCoursePreviewStep: React.FC<
  CustomizeCoursePreviewStepProps
> = ({ course, onSkipTranslation, onTranslate }) => {
  const { t } = useTranslation();

  return (
    <FlexContainer direction="column" gap={32}>
      <CourseContentPreview course={course} />
      <FlexContainer gap={14} align="center" justify="flex-end">
        <AppButton
          label={t('course.customization.preview.skipTranslation')}
          onClick={onSkipTranslation}
          isDisabled={false}
          type="outlined"
        />
        <AppButton
          label={t('course.customization.preview.translateContent')}
          onClick={onTranslate}
          isDisabled={false}
        />
      </FlexContainer>
    </FlexContainer>
  );
};
